// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'c637554e434a824a5c08caa5cd0a94f0ba5d96fb';
export const BUILD_NUMBER = '253';
export const BUILD_TIMESTAMP = '2026-09-28T09:43:26.290Z';
